module.exports = __webpack_public_path__ + "static/media/fonts-9-mobile.785377d8.svg";